import PublicRoutes from "../../routes/public-routes";

const Body = () => {
  return (
    <div className="relative mt-[68px] md:mt-[88px]">
      <PublicRoutes />
    </div>
  );
};

export default Body;
